var map = {
	"./en.json": [
		"AY7x",
		1
	],
	"./pt.json": [
		"dLoh",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = "Bvf9";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3048926480/src/src/assets/translations async ^\.\/.*\.json$
// module id = Bvf9
// module chunks = 2